import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Typography, Chip } from '@mui/material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { handleDownloadDocument, documentTypeOptions } from '../_Utils/AppDocuCommon';
import AppDocuServiceCall from '../_Utils/AppDocuServiceCall';

export default class DialogDocumentDetails extends React.Component {
  state = { loading: false, doc: null };

  async componentDidUpdate(prevProps) {
    if (this.props.documentId && this.props.documentId !== prevProps.documentId) {
      this.setState({ loading: true });
      try {
        const res = await AppDocuServiceCall.getDocument(this.props.documentId);
        const doc = res.data.document || null;
        this.setState({ doc, loading: false });
      } catch (e) {
        this.setState({ loading: false });
      }
    }
  }

  renderValue = value => value ? (
    <Typography variant="body1" sx={{ color: 'grey.900' }}>{value}</Typography>
  ) : (
    <Typography variant="body2" sx={{ color: '#bdbdbd', textTransform: 'uppercase' }}>undefined</Typography>
  );

  render() {
    const { doc, loading } = this.state;
    const { open, onClose } = this.props;
    // Trova le props dal nuovo array documentTypeOptions
    const docTypeProps = doc ? (documentTypeOptions.find(opt => opt.name === doc.document_type) || { color: '#1976d2', label: doc.document_type }) : { color: '#1976d2', label: '' };
    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Document Details</DialogTitle>
        <DialogContent>
          {loading && <Typography>Loading...</Typography>}
          {doc && (
            <Stack spacing={2}>
              <Typography variant="h5" sx={{ fontWeight: 700, color: 'primary.main' }}>{doc.name}</Typography>
              <div>
                <Typography variant="caption" sx={{ color: 'grey.700' }}>File Name</Typography>
                {this.renderValue(doc.original_filename)}
              </div>
              <div>
                <Typography variant="caption" sx={{ color: 'grey.700' }}>Com Brand</Typography>
                <Typography variant="body1">{doc.com_brand}</Typography>
              </div>
              <div>
                <Typography variant="caption" sx={{ color: 'grey.700' }}>Document Type</Typography>
                <Typography variant="body1" sx={{ color: docTypeProps.color, textTransform: 'uppercase' }}>{docTypeProps.label}</Typography>
              </div>
              <div>
                <Typography variant="caption" sx={{ color: 'grey.700' }}>Description</Typography>
                {this.renderValue(doc.description)}
              </div>
              <div>
                <Typography variant="caption" sx={{ color: 'grey.700' }}>Language</Typography>
                {this.renderValue(doc.language)}
              </div>                     
            </Stack>
          )}
        </DialogContent>
        <DialogActions>
          {doc && (
            <Button
              onClick={() => handleDownloadDocument(doc)}
              color="primary"
            >
              Download
            </Button>
          )}
          <Button onClick={onClose}>Close</Button>
        </DialogActions>
      </Dialog>
    );
  }
}
